/** The address of a file the Company Directory keeps (a profile photo): absolute as it is, or on this app's API. */
export const dossierAssetUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  const base = process.env.REACT_APP_API_URL || '';
  return `${base}${url}`;
};

export default dossierAssetUrl;
